import { clearToken } from "./auth";

/**
 * A 401 from one route does not mean the session is dead.
 *
 * Parts of `/v1/admin/*` are reachable only with the static operator bearer and
 * answer a perfectly valid SSO token with **401**, not 403. Wiring
 * `onUnauthorized` straight to `clearToken` therefore logs the operator out on
 * the first such call. The session provider registers a handler that re-probes
 * the identity endpoint and only gives up when *that* is refused too.
 *
 * Before a handler is registered (the unauthenticated shell) the old behaviour
 * stands: clear the token.
 */
type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;

export function setUnauthorizedHandler(fn: UnauthorizedHandler | null): void {
  handler = fn;
}

export function notifyUnauthorized(): void {
  if (handler) {
    handler();
    return;
  }
  clearToken();
}
